import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Modal } from '@blueprint/ui';
import { styled as zds } from '@zoopla-eng/zds-components/themes';
import { Box } from '@zoopla-eng/zds-components/box';

export const SkipLinkContainer = zds(Box, {
    textAlign: 'center'
});

export const StyledModal = styled(Modal)(
    ({ theme: { mediaQueries } }) => css`
        ${mediaQueries.small} {
            min-height: 90vh;
        }
    `
);
